import {StyleSheet} from "aphrodite-jss"

export const styles = StyleSheet.create({
    container : {
        height: "wrap-content",
        minHeight: "150px",
        minWidth: "400px",
        width: "400",
        maxWidth: "600px",
        backgroundColor: "white",
        padding: "10px",
    },
    content: {
        display: "flex",
        flexDirection: "column"
    },
    title: {
        fontSize: "25px",
        fontWeight: "bold"
    },
    row: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        marginTop: "5px",
        "& #label": {
            marginRight: "10px"
        }
    },
    subject_areas:  {
        display: "flex",
        flexDirection: "row",
        alignItems: "top",
        marginTop: "5px",
        "& #label": {
            marginRight: "10px",
            whiteSpace: "nowrap"
        },
        "& #content": {
            overflowWrap: "anywhere"
        }
    },
    button: {
        margin: "15px auto 15px auto",
        padding: "5px 15px 5px 15px",
        width: "min-content",
        color: "white",
        backgroundColor: "rgb(0, 83, 159)",
        "&:hover" : {
            backgroundColor: "rgb(0, 55, 107)",
            color: "white"
        },
        "user-select": "none",
        whiteSpace: "nowrap"
    }

});


// WEBPACK FOOTER //
// ./src/components/dialogs/SourceDetailDialogStyle.ts